import * as React from "react";

function Loading() {
    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div className="tmp-loading">
                <i className="tmp-loading-icon fas fa-spinner fa-spin fa-3x"></i>
            </div>
        </div>
    );
}

export default Loading;
